import { GzEndpointListWebComponent } from './component/GzEndpointListWebComponent';
import { WEB_COMPONENT_GZ_ENDPOINT_LIST } from '../../webcomponents.constants';

export { GzEndpointListWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_ENDPOINT_LIST, GzEndpointListWebComponent);
